<template>
  <div id="detailsproduct">
    <Header />
    <DetailsProduct />
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/template/Header";
import DetailsProduct from "@/components/details/DetailsProduct";
import Footer from "@/components/template/Footer";
import axios from "axios";
export default {
  name: "Details",
  data() {
    return {
      produto: {},
      precoProduto: null,
      nomeProduto: null,
      linkDaPagina: null,
    };
  },
  components: {
    Header,
    DetailsProduct,
    Footer,
  },

  async created() {
    var url = new URL(window.location.href);
    var sku = url.searchParams.get("sku");
    let precoProduto = JSON.parse(localStorage.getItem("precoDetails"));

    this.precoProduto = precoProduto.preco;
    const response = await axios({
      method: "get",
      url: `https://www.leverosintegra.com.br/map/api/GetItemData/${sku}`,
    });

    this.produto = response.data;

    this.nomeProduto = this.produto.NameComplete.split(" ")
      .slice(0, 1)
      .join(" ");

    this.linkDaPagina = window.location.href;
  },

  metaInfo() {
    return {
      title: `${this.produto.NameComplete} | Leveros Integra`,
      meta: [
        {
          name: "description",
          content: `${this.produto.NameComplete} você encontra na Leveros. Adquira já o seu ${this.nomeProduto} em até 10X Sem Juros!`,
        },
        { name: "robots", content: "index,follow" },
        { name: "country", content: "BRA" },
        { name: "currency", content: "R$" },
        { name: "author", content: "Leveros Integra" },
        { name: "copyright", content: "Leveros Integra" },
        {
          property: "og:title",
          content: `${this.produto.NameComplete} | Leveros Integra`,
        },
        {
          property: "og:description",
          content: `${this.produto.NameComplete} você encontra na Leveros. Adquira já o seu ${this.nomeProduto} em até 10X Sem Juros!`,
        },
        { property: "og:site_name", content: "Leveros Integra" },
        { property: "og:author", content: "Leveros Integra" },
        { property: "og:url", content: `${this.linkDaPagina}` },
        { property: "og:type", content: "company" },
      ],
      link: [{ rel: "canonical", href: `${this.linkDaPagina}` }],
    };
  },
};
</script>